import { render, staticRenderFns } from "./NewsFeedContainer.vue?vue&type=template&id=96c09632&scoped=true&"
import script from "./NewsFeedContainer.vue?vue&type=script&lang=js&"
export * from "./NewsFeedContainer.vue?vue&type=script&lang=js&"
import style0 from "./NewsFeedContainer.vue?vue&type=style&index=0&lang=css&"
import style1 from "./NewsFeedContainer.vue?vue&type=style&index=1&id=96c09632&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c09632",
  null
  
)

export default component.exports